<template>
  <div class="commission-wrap">
    <div class="breadcrumb-wrap">
      <h2>Commission</h2>
      <ul class="breadcrumb">
        <li>
          <router-link :to="{name: 'Home'}"><i class="bx bxs-home"></i>Home</router-link>
        </li>
        <li>
          <router-link :to="{name: 'Dashboard'}"><i class="bx bxs-dashboard"></i>Dashboard</router-link>
        </li>
        <li>
          <span>Commission</span>
        </li>
      </ul>
    </div>
    <div class="commission-box" :class="{ 'loading': isProcessing }">
      <div class="item">
        <div class="item-head">
          <h4><img src="/assets/images/icons/commission-2.png" alt="Commission">Referral Commission</h4>
        </div>
        <div class="item-body">
          <div class="flex-box"><img src="/assets/images/icons/usdt.png" alt="USDT"><span class="number">{{ userOverview.beautyTotalComRefU }}</span><span class="text">USDT</span></div>
          <div class="flex-box"><img src="/assets/images/icons/aleo.png" alt="ALEO"><span class="number">{{ userOverview.beautyTotalComRefA }}</span><span class="text">ALEO</span></div>
          <div class="flex-box"><img src="/assets/images/icons/kas.png" alt="KAS"><span class="number">{{ userOverview.beautyTotalComRefK }}</span><span class="text">KAS</span></div>
        </div>
        <div class="item-footer">
          <h5><i class="el-icon-alarm-clock"></i>Payout daily commission</h5>
          <flip-countdown :deadline="deadline" :showDays="false" countdownSize="20px" labelSize="15px"></flip-countdown>
        </div>
        <div class="item-tip">
          <i class="el-icon-info"></i>
          <em>Note: Commissions daily will be paid daily at 00:00 UTC</em>
        </div>
      </div>
      <div class="item">
        <div class="item-head">
          <h4><img src="/assets/images/icons/commission-2.png" alt="Commission">Rank Commission</h4>
        </div>
        <div class="item-body">
          <div class="flex-box"><img src="/assets/images/icons/usdt.png" alt="USDT"><span class="number">{{ userOverview.beautyTotalComBrandU }}</span><span class="text">USDT</span></div>
          <div class="flex-box"><img src="/assets/images/icons/aleo.png" alt="ALEO"><span class="number">{{ userOverview.beautyTotalComBrandA }}</span><span class="text">ALEO</span></div>
          <div class="flex-box"><img src="/assets/images/icons/kas.png" alt="KAS"><span class="number">{{ userOverview.beautyTotalComBrandK }}</span><span class="text">KAS</span></div>
        </div>
        <div class="item-footer">
          <h5><i class="el-icon-alarm-clock"></i>Payout daily commission</h5>
          <flip-countdown :deadline="deadline" :showDays="false" countdownSize="20px" labelSize="15px"></flip-countdown>
        </div>
        <div class="item-tip">
          <i class="el-icon-info"></i>
          <em>Note: Commissions daily will be paid daily at 00:00 UTC</em>
        </div>
      </div>
      <div class="item">
        <div class="item-head">
          <h4><img src="/assets/images/icons/mining.png" alt="mining">Mining Token</h4>
        </div>
        <div class="item-body">
          <div class="flex-box"><img src="/assets/images/icons/aleo.png" alt="ALEO"><span class="number">{{ userOverview.aleoMining || 0 }}</span><span class="text">ALEO</span></div>
          <div class="flex-box"><img src="/assets/images/icons/iron.png" alt="IRON"><span class="number">{{ userOverview.ironMining || 0 }}</span><span class="text">IRON</span></div>
          <div class="flex-box"><img src="/assets/images/icons/kas.png" alt="KAS"><span class="number">{{ userOverview.kasMining || 0 }}</span><span class="text">KAS</span></div>
        </div>
      </div>
      <div class="item">
        <div class="item-head">
          <h4><img src="/assets/images/icons/hourglass.png" alt="hourglass">Next Daily Commission</h4>
        </div>
        <div class="item-body">
          <div class="flex-box"><img src="/assets/images/icons/usdt.png" alt="USDT"><span class="number">{{ commissionEstimation.usdt }}</span><span class="text">USDT</span></div>
          <div class="flex-box"><img src="/assets/images/icons/aleo.png" alt="ALEO"><span class="number">{{ commissionEstimation.aleo }}</span><span class="text">ALEO</span></div>
          <div class="flex-box"><img src="/assets/images/icons/iron.png" alt="IRON"><span class="number">{{ commissionEstimation.iron }}</span><span class="text">IRON</span></div>
          <div class="flex-box"><img src="/assets/images/icons/kas.png" alt="KAS"><span class="number">{{ commissionEstimation.kas || 0 }}</span><span class="text">KAS</span></div>
        </div>
        <div class="item-footer">
          <h5><i class="el-icon-alarm-clock"></i>Payout daily commission</h5>
          <flip-countdown :deadline="deadline" :showDays="false" countdownSize="20px" labelSize="15px"></flip-countdown>
        </div>
      </div>
      <div class="item">
        <div class="item-head">
          <h4><img src="/assets/images/icons/reward.png" alt="hourglass">Maxout</h4>
        </div>
        <div class="item-body">
          <p>Total Invest: {{ userMaxout.beautyTotalInvest }} USDT</p>
          <p>Total Commission: {{ userMaxout.beautyTotalCom }} USDT</p>
          <p>Maxout: {{ userMaxout.beautyMaxout }} USDT</p>
          <div class="range" :style="`--p:${userMaxout.percentView}`"></div>
          <div class="item-tip mt-2" style="padding-left: 0;">
            <i class="el-icon-info"></i>
            <em>Maxout commission you get upto {{ percent }}% of your investment.</em>
          </div>
          <div class="item-tip mt-2" style="padding-left: 0;">
            <i class="el-icon-info"></i>
            <em>Note: From April 6, 2024: All affiliate commission coefficients change from 100% to 80%</em>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="item-head">
          <h4><img src="/assets/images/icons/reward.png" alt="hourglass">Mining Performance</h4>
        </div>
        <div class="item-body">
          <p>Hashrate: {{ configs.kasCalculationsHashRate }} Th/s</p>
          <p>Power: {{ configs.kasCalculationsPower }} W</p>
          <p>Cost: {{ configs.kasCalculationsCost }} $/kWh</p>
          <p>International mining pool performance: 1 Gh/s get <b class="green-color">{{configs.kasEstRewards}}</b> KAS daily</p>
          <p>RRG mining pool performance: 1 Gh/s get <b class="green-color">{{configs.kasRrgRewards}}</b> KAS daily</p>
          <p>Refer: <a target="_blank" :href="configs.kasCalculationsUrl">Click here</a></p>
        </div>
      </div>
    </div>
    <div class="history-section" :class="{ 'loading': isLoadingHistory }">
      <div class="table-box">
        <div class="title">
          <h2>History</h2>
        </div>
        <div class="controls">
          <el-button :class="{'active': currentTab ===  1}" @click="showTab(1)">Mining</el-button>
          <el-button :class="{'active': currentTab ===  2}" @click="showTab(2)">USDT Referral</el-button>
          <el-button :class="{'active': currentTab ===  3}" @click="showTab(3)">ALEO Referral</el-button>
          <el-button :class="{'active': currentTab ===  6}" @click="showTab(6)">KAS Referral</el-button>
          <el-button :class="{'active': currentTab ===  4}" @click="showTab(4)">USDT Rank</el-button>
          <el-button :class="{'active': currentTab ===  5}" @click="showTab(5)">ALEO Rank</el-button>
          <el-button :class="{'active': currentTab ===  7}" @click="showTab(7)">KAS Rank</el-button>
        </div>
        <div class="table-fixed-wrap">
          <div class="table-box-inner">
            <template v-if="currentTab === 1">
              <dl class="table-small2">
                <dt>
                  <div class="item-no">{{ $t('TEXT_NO') }}.</div>
                  <div>Symbol</div>
                  <div>Power</div>
                  <div>Rate</div>
                  <div>Percent</div>
                  <div>Amount</div>
                  <div class="flex-1">Date</div>
                </dt>
                <template v-if="commissionAleoHistory.length">
                  <dd v-for="(history, index) in commissionAleoHistory" :key="index">
                    <div class="item-no">{{ index + 1 }}</div>
                    <div>{{ history.symbol }}</div>
                    <div>{{ history.totalPower.toFixed(3) }}</div>
                    <div>{{ history.rateMining }}</div>
                    <div>{{ (history.percent * 100).toFixed(2) }}%</div>
                    <div>{{ history.beautyAmount }}</div>
                    <div class="flex-1">{{ history.date }}</div>
                  </dd>
                </template>
                <template v-else>
                  <dd class="no-data-wrap">
                    <div class="no-data">{{ $t('TEXT_NO_DATA') }}</div>
                  </dd>
                </template>
                <el-pagination
                  :current-page="pagination.currentPage"
                  :page-count="pagination.totalPage"
                  background
                  layout="prev, pager, next"
                  @current-change="goToPage"
                  :hide-on-single-page="true"
                >
                </el-pagination>
              </dl>
            </template>
            <template v-if="currentTab === 2 || currentTab === 3 || currentTab === 6">
              <dl class="table-medium">
                <dt>
                  <div class="item-no">No.</div>
                  <div>Username</div>
                  <div>Amount</div>
                  <div>Percent (%)</div>
                  <template v-if="currentTab !== 3">
                    <div>Ratio</div>
                    <div class="width-1_5x">Ratio x Percent (%)</div>
                  </template>
                  <div class="width-1_5x">Amount Commission</div>
                  <div>Level</div>
                  <div>Symbol</div>
                  <div class="flex-1">Date</div>
                </dt>
                <template v-if="commissionHistory.length">
                  <dd v-for="(history, index) in commissionHistory" :key="index">
                    <div class="item-no">{{ index + 1 }}</div>
                    <div>{{ history.fromUser }}</div>
                    <div>{{ history.beautyFromAmount }}</div>
                    <div>{{history.percentHistory}}</div>
                    <template v-if="currentTab !== 3">
                      <div>{{ history.ratio }}</div>
                      <div class="width-1_5x">{{ (history.percent * 100).toFixed(2) }}</div>
                    </template>
                    <div class="width-1_5x">{{ history.beautyAmount }}</div>
                    <div>F{{ history.level }}</div>
                    <div>{{ history.symbol }}</div>
                    <div class="flex-1">{{ history.date }}</div>
                  </dd>
                </template>
                <template v-else class="no-data-wrap">
                  <div class="no-data">No Data</div>
                </template>
                <el-pagination
                  :current-page="pagination.currentPage"
                  :page-count="pagination.totalPage"
                  background
                  layout="prev, pager, next"
                  @current-change="goToPage"
                  :hide-on-single-page="true"
                >
                </el-pagination>
              </dl>
            </template>
            <template v-if="currentTab === 4 || currentTab === 5 || currentTab === 7">
              <dl class="table-medium">
                <dt>
                  <div class="item-no">No.</div>
                  <div>Username</div>
                  <div>Amount</div>
                  <div>Percent (%)</div>
                  <template v-if="currentTab !== 5">
                    <div>Ratio</div>
                    <div class="width-1_5x">Ratio x Percent (%)</div>
                  </template>
                  <div class="width-1_5x">Amount Commission</div>
                  <div>Level</div>
                  <div>Symbol</div>
                  <div class="flex-1">Date</div>
                </dt>
                <template v-if="commissionBrandHistory.length">
                  <dd v-for="(history, index) in commissionBrandHistory" :key="index">
                    <div class="item-no">{{ index + 1 }}</div>
                    <div>{{ history.fromUser }}</div>
                    <div>{{ history.beautyFromAmount }}</div>
                    <div>{{ history.percentHistory}}</div>
                    <template  v-if="currentTab !== 5">
                      <div>{{ history.ratio }}</div>
                      <div class="width-1_5x">{{ (history.percent * 100).toFixed(2) }}</div>
                    </template>
                    <div>{{ history.beautyAmount }}</div>
                    <div>{{ history.role }}</div>
                    <div>{{ history.symbol }}</div>
                    <div class="flex-1" v-if="history.date">{{ history.date }}</div>
                    <div class="flex-1" v-else>{{ history.beautyCreatedAtUtc }}</div>
                  </dd>
                </template>
                <template v-else class="no-data-wrap">
                  <div class="no-data">No Data</div>
                </template>
                <el-pagination
                  :current-page="pagination.currentPage"
                  :page-count="pagination.totalPage"
                  background
                  layout="prev, pager, next"
                  @current-change="goToPage"
                  :hide-on-single-page="true"
                >
                </el-pagination>
              </dl>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FlipCountdown from 'vue2-flip-countdown'
export default {
  components: {
    FlipCountdown
  },
  data () {
    return {
      deadline: null,
      currentTab: 1,
      isLoadingHistory: false,
      isProcessing: false
    }
  },
  computed: {
    configs () {
      return this.$store.getters.configs
    },
    percent () {
      return this.configs.percentMaxOut * 100
    },
    userOverview () {
      return this.$store.getters.userOverview
    },
    userMaxout () {
      return this.$store.getters.userMaxout
    },
    pagination () {
      return this.$store.getters.pagination
    },
    commissionHistory () {
      return this.$store.getters.commissionHistory
    },
    commissionAleoHistory () {
      return this.$store.getters.commissionAleoHistory
    },
    commissionBrandHistory () {
      return this.$store.getters.commissionBrandHistory
    },
    commissionEstimation () {
      return this.$store.getters.commissionEstimation
    }
  },
  async created () {
    this.isProcessing = true
    const date = new Date()
    date.setDate(date.getDate() + 1)
    date.setUTCHours(0)
    date.setUTCMinutes(0)
    date.setUTCSeconds(0)
    this.deadline = date.toUTCString()

    await this.getHistory()
    this.$store.dispatch('getUserMaxout').then(rs => {})
    this.$store.dispatch('getCommissionEstimation')
    setTimeout(() => {
      this.isProcessing = false
    }, 500)
    // this.$store.dispatch('miningToken')
  },
  methods: {
    showTab (tab) {
      this.currentTab = tab
      this.getHistory()
    },
    async getHistory (page = 1) {
      this.isLoadingHistory = true
      switch (this.currentTab) {
        case 1:
          await this.$store.dispatch('getCommissionAleoHistory', page)
          break
        case 2:
          await this.$store.dispatch('getCommissionRefHistory', { page, symbol: 'usdt' })
          break
        case 3:
          await this.$store.dispatch('getCommissionRefHistory', { page, symbol: 'aleo' })
          break
        case 4:
          await this.$store.dispatch('getCommissionBrandHistory', { page, symbol: 'usdt' })
          break
        case 5:
          await this.$store.dispatch('getCommissionBrandHistory', { page, symbol: 'aleo' })
          break
        case 6:
          await this.$store.dispatch('getCommissionRefHistory', { page, symbol: 'kas' })
          break
        case 7:
          await this.$store.dispatch('getCommissionBrandHistory', { page, symbol: 'kas' })
          break
      }
      setTimeout(() => {
        this.isLoadingHistory = false
      }, 300)
    },
    goToHistory () {
      this.$router.push({ name: 'Commission' })
    },
    goToPage (page) {
      const temp = JSON.parse(JSON.stringify(this.pagination))
      temp.page = page
      this.$store.dispatch('setPagination', temp)
      this.getHistory(page)
    }
  }
}
</script>
